
import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { AlertCircle, Plus, Table, Kanban } from 'lucide-react';
import { useIncidentes } from '@/hooks/useIncidentes';
import { Solicitacao } from '@/types/solicitacao';
import IncidenteStatsCards from './IncidenteStatsCards';
import IncidentesTable from './IncidentesTable';
import IncidentesKanban from './IncidentesKanban';
import EditIncidenteDialog from './EditIncidenteDialog';
import { NewIncidenteDialog } from './NewIncidenteDialog';

const IncidentesManagement = () => {
  const { incidentes, isLoading } = useIncidentes();
  const [editingIncidente, setEditingIncidente] = useState<Solicitacao | null>(null);
  const [newIncidenteDialogOpen, setNewIncidenteDialogOpen] = useState(false);
  const [viewMode, setViewMode] = useState<'table' | 'kanban'>('table');

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="text-lg">Carregando incidentes...</div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <AlertCircle className="h-6 w-6" />
          <h1 className="text-2xl font-bold">Incidentes</h1>
        </div>
        <div className="flex items-center gap-2">
          <div className="flex items-center bg-gray-100 rounded-lg p-1">
            <Button
              variant={viewMode === 'table' ? 'default' : 'ghost'}
              size="sm"
              onClick={() => setViewMode('table')}
              className="flex items-center gap-2"
            >
              <Table className="h-4 w-4" />
              Tabela
            </Button>
            <Button
              variant={viewMode === 'kanban' ? 'default' : 'ghost'}
              size="sm"
              onClick={() => setViewMode('kanban')}
              className="flex items-center gap-2"
            >
              <Kanban className="h-4 w-4" />
              Kanban
            </Button>
          </div>
          <Button 
            className="bg-blue-600 hover:bg-blue-700"
            onClick={() => setNewIncidenteDialogOpen(true)}
          >
            <Plus className="h-4 w-4 mr-2" />
            Novo Incidente
          </Button>
        </div>
      </div>
      <NewIncidenteDialog
        isOpen={newIncidenteDialogOpen}
        onClose={() => setNewIncidenteDialogOpen(false)}
      />

      <IncidenteStatsCards incidentes={incidentes} />
      
      {viewMode === 'table' ? (
        <IncidentesTable 
          incidentes={incidentes} 
          onEditIncidente={setEditingIncidente} 
          onNewIncidente={() => setNewIncidenteDialogOpen(true)} 
        />
      ) : (
        <IncidentesKanban 
          incidentes={incidentes} 
          onEditIncidente={setEditingIncidente} 
        />
      )}
      {editingIncidente && (
        <EditIncidenteDialog 
          incidente={editingIncidente}
          isOpen={!!editingIncidente}
          onClose={() => setEditingIncidente(null)}
        />
      )}
    </div>
  )
}

export default IncidentesManagement;

